import { render, staticRenderFns } from "./typingIndicator.vue?vue&type=template&id=47131824&"
import script from "./typingIndicator.vue?vue&type=script&lang=js&"
export * from "./typingIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports